module.exports = __webpack_public_path__ + "img/news.dcb177d7.jpg";